import { useAppDispatch } from "app.hook";
import React, { FC, useEffect, useState } from "react";
import { useParams } from "react-router";
import { formatMoney, formatPhone } from "shared/plugins/string-helper";
import {
  setActiveMenu,
  setLoading,
} from "states/global-value/global-value.slice";
import { getOrderAPI } from "states/order/order.api";
import { IOrderModel, OrderPaymentModel } from "states/order/order.models";
import { IconAddress, IconInvoice, IconShopFill } from "themes/icons";
import moment from "moment-timezone";
import {
  OrderDetailMobile,
  OrderDetailMobileSection,
  OrderItemProductMobileSection,
  OrderTable,
  OrderTotalMobileSection,
} from "./style/order-style";
import { momentDateTimeFormat } from "shared/plugins/localization";
interface IOrderParams {
  id: string;
}
const OrderDetailPage: FC = (props) => {
  const params = useParams<IOrderParams>();
  const [model, setModel] = useState<IOrderModel>({
    orderPayments: [] as OrderPaymentModel[],
  } as IOrderModel);
  const dispatch = useAppDispatch();
  const getOrder = async () => {
    dispatch(setLoading(true));
    let result = (await getOrderAPI(params.id)).data;
    setModel(result);
    dispatch(setLoading(false));
  };
  useEffect(() => {
    document.title = "Order Detail";
    getOrder();
    dispatch(setActiveMenu("order"));
  }, []);
  return (
    <>
      <OrderDetailMobile>
        <OrderDetailMobileSection>
          <div className="heading">
            <IconAddress className="icon__left" width={25} />
            <div className="content">
              <div className="title">Location: {model?.branch?.name}</div>
              <div className="date">
                Timezone: {model?.branch?.ianaTimeZone}
              </div>
            </div>
          </div>
        </OrderDetailMobileSection>
        <OrderDetailMobileSection>
          <div className="heading">
            <IconInvoice className="icon__left" width={25} />
            <div className="content">
              <div className="title">Invoice Number: {model?.orderNumber}</div>
              <div className="date">
                Order Date :{" "}
                {model?.requestPickupTime &&
                  moment(model?.requestPickupTime)
                    .tz(model?.branch?.ianaTimeZone)
                    .format(momentDateTimeFormat())}
              </div>
              <div className="status">
                {model?.paymentDone ? "Paid" : "Pending"}
              </div>
            </div>
          </div>
        </OrderDetailMobileSection>
        {model?.orderPayments[0] && (
          <OrderDetailMobileSection>
            <div className="heading">
              <IconAddress className="icon__left" width={25} />
              <div className="content">
                <div className="title">Billing Information</div>
                <div className="date">
                  Name:{" "}
                  {`${model?.orderPayments[0]?.billingAddress?.firstName} ${model?.orderPayments[0]?.billingAddress?.lastName}`.toUpperCase()}
                </div>
                <div className="date">
                  Phone:{" "}
                  {model?.orderPayments[0]?.billingAddress?.phoneNumber &&
                    formatPhone(
                      model?.orderPayments[0]?.billingAddress?.phoneNumber
                    )}
                </div>
                {model?.orderPayments[0] && (
                  <>
                    <div className="status">Payment Method: Credit Card</div>
                    {model?.orderPayments[0].billingAddress && (
                      <div className="status flex">
                        <span className="mr-2">Address:</span>
                        <p>
                          {`${model?.orderPayments[0]?.billingAddress?.street},`}
                          <br />
                          {`${model?.orderPayments[0]?.billingAddress?.provinceName}, ${model?.orderPayments[0]?.billingAddress?.stateCode} ${model?.orderPayments[0]?.billingAddress?.postalCode}, ${model?.orderPayments[0]?.billingAddress?.countryCode} `}
                        </p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </OrderDetailMobileSection>
        )}
        {(model?.cartPromotionName || model?.couponCode) && (
          <OrderDetailMobileSection>
            <div className="heading">
              <IconAddress className="icon__left" width={25} />
              <div className="content">
                <div className="title">Promotion</div>
                {model?.cartPromotionName && (
                  <div className="date">
                    Cart Promotion Name: {model?.cartPromotionName}
                  </div>
                )}
                {model?.couponCode && (
                  <div className="date">
                    Promotion Code: {model?.cartPromotionName}
                  </div>
                )}
              </div>
            </div>
          </OrderDetailMobileSection>
        )}

        <OrderDetailMobileSection>
          <div className="heading">
            <IconShopFill className="icon__left" width={25} />
            <div className="content">
              <div className="title">Order Information</div>
            </div>
          </div>
          <div className="info">
            {model?.orderItems?.map((m) => (
              <OrderItemProductMobileSection>
                <img
                  src={m.product.images.length > 0 ? m.product.images[0] : ""}
                  alt=""
                />
                <div className="product-info">
                  <div className="name">{m.product?.name} | {formatMoney(m.price, 2, ".", ",", "$")}</div>
                  <div className="modifiers">
                    {m.modifiers.map((mo) => (
                      <span>{mo.product?.name} | {formatMoney(mo.price, 2, ".", ",", "$")} </span>
                    ))}
                  </div>
                  <div className="price">
                    Qty: {m.quantity}
                  </div>
                  <div className="price">
                    Total: {formatMoney((m.price + m.modifiers.map(mo => mo.price * mo.quantity).reduce((a, b) => a + b, 0)) * m.quantity, 2, ".", ",", "$")}
                  </div>
                </div>
              </OrderItemProductMobileSection>
            ))}
          </div>
        </OrderDetailMobileSection>
        <div className="mt-2 bg-white">
          <OrderTotalMobileSection>
            <div className="summary__name">Subtotal</div>
            <div className="summary__price">
              {model?.subTotal &&
                formatMoney(model?.subTotal, 2, ".", ",", "$")}
            </div>
          </OrderTotalMobileSection>
          <OrderTotalMobileSection>
            <div className="summary__name">Discount</div>
            <div className="summary__price">
              {model?.discountAmount &&
                formatMoney(model?.discountAmount, 2, ".", ",", "$")}
            </div>
          </OrderTotalMobileSection>
          <OrderTotalMobileSection>
            <div className="summary__name">Tip</div>
            <div className="summary__price">
              {model?.tipAmount &&
                formatMoney(model?.tipAmount, 2, ".", ",", "$")}
            </div>
          </OrderTotalMobileSection>
          <OrderTotalMobileSection>
            <div className="summary__name">Taxes</div>
            <div className="summary__price">
              {model.taxes && formatMoney(model?.taxes, 2, ".", ",", "$")}
            </div>
          </OrderTotalMobileSection>
          {model?.additionalTaxes?.map(((m, i) => (
            <OrderTotalMobileSection key={i}>
              <div className="summary__name">{m.taxName}</div>
              <div className="summary__price">
                {formatMoney(m.feeAmount, 2, ".", ",", "$")}
              </div>
            </OrderTotalMobileSection>
          )))}
          <OrderTotalMobileSection>
            <div className="summary__name">
              Convenient fee
            </div>
            <div className="summary__price">
              {model.nonCashAdjFee && formatMoney(model?.nonCashAdjFee, 2, ".", ",", "$")}
            </div>
          </OrderTotalMobileSection>
          <OrderTotalMobileSection>
            <div className="summary__name">Total</div>
            <div className="summary__price">
              {model?.totalAmount &&
                formatMoney(model?.totalAmount, 2, ".", ",", "$")}
            </div>
          </OrderTotalMobileSection>
        </div>
      </OrderDetailMobile>
    </>
  );
};

export default OrderDetailPage;
